/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserMessageSeverity } from './UserMessageSeverity';
import {
    UserMessageSeverityFromJSON,
    UserMessageSeverityFromJSONTyped,
    UserMessageSeverityToJSON,
    UserMessageSeverityToJSONTyped,
} from './UserMessageSeverity';
import type { ActiveDirectoryAction } from './ActiveDirectoryAction';
import {
    ActiveDirectoryActionFromJSON,
    ActiveDirectoryActionFromJSONTyped,
    ActiveDirectoryActionToJSON,
    ActiveDirectoryActionToJSONTyped,
} from './ActiveDirectoryAction';

/**
 * 
 * @export
 * @interface ActiveDirectoryUserIdResponse
 */
export interface ActiveDirectoryUserIdResponse {
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdResponse
     */
    version: string;
    /**
     * 
     * @type {ActiveDirectoryAction}
     * @memberof ActiveDirectoryUserIdResponse
     */
    action: ActiveDirectoryAction;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdResponse
     */
    userMessage?: string | null;
    /**
     * 
     * @type {UserMessageSeverity}
     * @memberof ActiveDirectoryUserIdResponse
     */
    messageSeverity?: UserMessageSeverity;
    /**
     * 
     * @type {number}
     * @memberof ActiveDirectoryUserIdResponse
     */
    status?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActiveDirectoryUserIdResponse
     */
    statusCode: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveDirectoryUserIdResponse
     */
    objectId?: string | null;
}



/**
 * Check if a given object implements the ActiveDirectoryUserIdResponse interface.
 */
export function instanceOfActiveDirectoryUserIdResponse(value: object): value is ActiveDirectoryUserIdResponse {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    return true;
}

export function ActiveDirectoryUserIdResponseFromJSON(json: any): ActiveDirectoryUserIdResponse {
    return ActiveDirectoryUserIdResponseFromJSONTyped(json, false);
}

export function ActiveDirectoryUserIdResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActiveDirectoryUserIdResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'action': ActiveDirectoryActionFromJSON(json['action']),
        'userMessage': json['userMessage'] == null ? undefined : json['userMessage'],
        'messageSeverity': json['messageSeverity'] == null ? undefined : UserMessageSeverityFromJSON(json['messageSeverity']),
        'status': json['status'] == null ? undefined : json['status'],
        'statusCode': json['statusCode'],
        'objectId': json['objectId'] == null ? undefined : json['objectId'],
    };
}

export function ActiveDirectoryUserIdResponseToJSON(json: any): ActiveDirectoryUserIdResponse {
    return ActiveDirectoryUserIdResponseToJSONTyped(json, false);
}

export function ActiveDirectoryUserIdResponseToJSONTyped(value?: ActiveDirectoryUserIdResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'action': ActiveDirectoryActionToJSON(value['action']),
        'userMessage': value['userMessage'],
        'messageSeverity': UserMessageSeverityToJSON(value['messageSeverity']),
        'status': value['status'],
        'statusCode': value['statusCode'],
        'objectId': value['objectId'],
    };
}

